import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { ResponseInputModule } from 'src/app/components/custom-fields/response-input/response-input.module';

import { AuthPageRoutingModule } from './auth-routing.module';
import { AuthPage } from './auth.page';

@NgModule({
  imports: [CommonModule, FormsModule, IonicModule, AuthPageRoutingModule, ResponseInputModule],
  declarations: [AuthPage],
})
export class AuthPageModule {}
